<template>
  <v-card class="mt-5" v-if="list.length">
    <div class="d-flex align-center px-5 pt-3">
      <h2 class="drawer-right__title my-0 font-weight-bold">
        <translate>Latest reviews</translate>
      </h2>
      <router-link
        :to="{
          name: 'courses.reviews'
        }"
        v-if="isShowSeeAll"
        @click.native="scrollToTop"
        class="ml-auto primary--text subtitle-2 pointer"
        ><translate>See all</translate>
        <v-icon size="20" color="primary" class="ml-1"
          >fal fa-angle-right</v-icon
        >
      </router-link>
    </div>
    <v-list-item
      three-line
      v-for="(val, key) in list"
      :key="key"
      class="d-block"
    >
      <v-list-item-content>
        <div class="d-flex avatarBox lastReview">
          <AvatarComponent size="38" :url="val.profile.picture" />
          <HeaderThumb :vlog="val" :reviewData="val.reviewData" />
        </div>

        <div class="containEllipsis">
          <div class="module overflow">
            <p>{{ val.content }}</p>
          </div>
        </div>

        <!-- <p class="mt-2 mb-0" ref="contentBox">
          {{ val.content }}
        </p> -->
      </v-list-item-content>
      <v-divider class="mt-3" v-if="key !== list.length - 1"></v-divider>
    </v-list-item>
  </v-card>
</template>
<script>
import ButtonLike from "@/components/Buttons/ButtonLike";
import GolfCourseService from "@/services/GolfCourseService";
import HeaderThumb from "@/components/Thumbnails/HeaderThumb";

export default {
  data() {
    return {
      list: []
    };
  },
  components: { ButtonLike, HeaderThumb },
  computed: {
    courseDetail() {
      return this.$store.state.golfcourse.courseDetail;
    },
    isShowSeeAll() {
      if (
        this.courseDetail &&
        Object.keys(this.courseDetail).length === 0 &&
        this.courseDetail.constructor === Object
      ) {
        return false;
      }
      return true;
    }
  },
  watch: {
    list() {
      this.$nextTick(() => {
        this.showSeeMore();
      });
    },
    courseDetail: {
      immediate: true,
      handler() {
        this.getData();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.showSeeMore();
    });
  },

  methods: {
    showSeeMore() {
      const heightContent = this.$refs.contentBox;

      for (let key in heightContent) {

        if (heightContent[key].clientHeight > 66) {
          console.log(this.list[key].content);
          this.list[key].content = this.removeWord(this.list[key].content)
        }
      }
    },
    removeWord(str) {
      var lastIndex = str.lastIndexOf(" ");

      str = str.substring(0, lastIndex);
      return str;
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },
    getData() {
      let val = this.courseDetail;
      if (val.id) {
        this.getCourseReviewList(val.id);
      } else {
        this.getListData();
      }
    },
    async getListData(page = 1, limit = 3, type = POST_TYPE_VLOG) {
      const data = await GolfCourseService.getAllReview(page, limit);
      if (data.error) {
        this.list = [];
      } else {
        this.list = data.list;
      }
    },

    async getCourseReviewList(id) {
      let data = await this.$store.dispatch("getCourseReview", {
        id: id,
        page: 1,
        limit: 3
      });
      if (data.error) {
        this.list = [];
      } else {
        this.list = data.list;
      }
    }
  },
  created() {
    let vm = this;
    vm.$root.$on("refreshLastReview", function() {
      vm.getData();
    });
  }
};
</script>
